import { render } from "./index.vue?vue&type=template&id=72b6c09d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72b6c09d&lang=scss"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__